module.exports = __webpack_public_path__ + "static/media/email-grey.591dfd6a.svg";